<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/worksheet_mn/FaultOrder_mn' }">故障记录</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/worksheet_mn/faultStatistics' }">{{formInline.vin}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{formInline.faultName}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="operation_list">
            <el-table size="small" :data="listData" highlight-current-row border style="width: 100%">
                <el-table-column align="center" prop="name" min-width="200" label="故障详情">
                </el-table-column>
                <el-table-column align="center" prop="value" min-width="200" label="故障次数">
                </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
    </div>
</template>

<script>
import { get_vin_fault_details_number } from "../../api/faultStatistics/faultStatistics"
import Pagination from "../../components/Pagination";
export default {
    data() {
        return {
            formInline: {
                vin: window.localStorage.getItem("fault_vin"),
                faultName: window.localStorage.getItem("faultName"),
                page: 1,
                limit: 10,
            },
            listData: [],
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10,
            },
        }
    },
    components: {
        Pagination,
    },
    //页面加载
    created() {
        this.getData()
    },
    methods: {
        getData() {
            get_vin_fault_details_number(this.formInline).then((res) => {
                if (res["code"] === 0) {
                    this.listData = res.data
                    this.pageparm.currentPage = this.formInline.page;
                    this.pageparm.pageSize = this.formInline.limit;
                    this.pageparm.total = res.total
                }
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage;
            this.formInline.limit = parm.pageSize;
            this.getData();
        },
    }
}
</script>

<style>
.operation_list {
    margin-top: 30px;
    width: 100%;
    height: 80px;
}
</style>


// WEBPACK FOOTER //
// src/views/worksheet_mn/faultType_mn.vue